import { render, staticRenderFns } from "./PrivacyModalContentOld1.vue?vue&type=template&id=2ca582ad&scoped=true"
var script = {}
import style0 from "./PrivacyModalContentOld1.vue?vue&type=style&index=0&id=2ca582ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca582ad",
  null
  
)

export default component.exports